import React, { Component } from 'react'
import logo from "../../assets/logo_espol_interno.svg";
import equis from "../../assets/eliminar.svg"
import check from "../../assets/check.svg";
import info from "../../assets/Info.png"
import "../../css/FormRegistro.css";
import axios from 'axios';
import FormRegistroContrasenia from './FormRegistroContrasenia';
import Modal from './Modal';
import Header from '../components/Header.js';
import CenteredWrapper from '../components/CenteredWrapper.js'
import Footer from '../components/Footer.js';
import anuncio from "../../assets/Anuncio.svg";
import anuncioico from "../../assets/AnuncioICO.svg";
import Acuerdo from './Acuerdo.js';
import BotonExpandible from "../components/BotonExpandible";
import RadioSwitch from "../components/RadioSwitch";
import jwt from 'jwt-decode'
import { useNavigate, Navigate } from "react-router-dom";
import LivenessModal from './LivenessModal.js';
import checkGreen from "../../assets/check.png";
import cedimg from "../../assets/FotoCEDULA.svg"
import cedimg_noveri from "../../assets/error-de-validacion.svg"
import cedimg_veri from "../../assets/validacion-exitosa.svg"

import NotificacionTip from "./NotificacionTip";
import Camara from "./Camara.js"
import Visualizarpdf from "../components/Visualizarpdf";
import ModalXL from './ModalXL';
import { jsPDF } from "jspdf";
import { isMobile } from 'react-device-detect';
import { base64ToPdfFile, base64ToFile } from "../../utils/funciones";
import focoanimado from "../../assets/focoanimado.gif";
import error from "../../assets/error.svg";
import alerta from "../../assets/alertacc.svg";
import checkcc from "../../assets/checkcc.svg";

export class FormRegistro extends Component {

    constructor(props) {
        super(props);

        this.state = {
            verRegistroContrasenia: false,
            verAcuerdo: false,
            verMensajeConocimiento: false,
            modalError: false,
            modalIsOpen: false,
            modalMensaje: "",
            mensaje_error_alias: "",
            datosUsuario: {
                id: this.props.id,
                identificacion: this.props.identificacion,
                nombres: this.props.nombres,
                apellidos: this.props.apellidos,
                alias_sugerido: this.props.alias_sugerido,
                usuarioEscogido: this.props.usuarioEscogido,
                listaUsuarios: this.props.usuarios,
                correoAlterno: this.props.correoAlterno,
                rol: this.props.rol,
                telefono: this.props.telefono,
                unidad: this.props.unidad,
            },
            expresiones: {
                //alias_sugerido: /^[a-z]+[/.][a-z]+$/,
                alias_sugerido: /^[a-z]+([/.][a-z]+)+$/,
            },
            errorSolicitud: {
                alias_sugerido: ""
            },
            modalSugerencia: {
                show: false,
                titulo: "Sugerencia de Alias",
                mensaje: "Los alias que te sugerimos utilizar es este:",
                imagen: info,
                listSug: [],
            },
            listSugerencia: [],
            activebutton: true,
            token_nueva_cuenta: sessionStorage.getItem("token_nueva_cuenta"),
            tiempoRestante: "",
            redirectInicio: false,
            personaviva: false,
            rostro_base64:"",
            iconGuardCedulaExito: false,
            isCedulaAnalizada: false,
            modalModocedula: false,
            modalCamaracedula: false,
            modalarchivocedula: false,
            showiconGuardPdfExitoCedula: false,
            isCedulaEqualRostro: false,
            isNumCedulaEqualBase: false,
            cedula_base64: "",
            necesitaRevision: false,
            spinnerUploadCamara: true,
            modalMessage: {
                show: false,
                titulo: "",
                mensaje: "",
                imagen: ""
            },
            vermodalresultvalidacionident: false,
            numerointento: 0,
            tipoCargaDocumentoIdentidad: ""
        };


        //this.renderFormRegistroContrasenia = this.renderFormRegistroContrasenia.bind(this);
        this.abrirModalInfoGTSI = this.abrirModalInfoGTSI.bind(this);
        this.cerrarModalInfoGTSI = this.cerrarModalInfoGTSI.bind(this);

        this.abrirModalError = this.abrirModalError.bind(this);
        this.cerrarModalError = this.cerrarModalError.bind(this);
        this.cerrarModalSesionExpirada = this.cerrarModalSesionExpirada.bind(this);


        this.abrirModalSugerencia = this.abrirModalSugerencia.bind(this);
        this.cerrarModalSugerencia = this.cerrarModalSugerencia.bind(this);

        this.abrirMensajeconocimiento = this.abrirMensajeconocimiento.bind(this);

        this.abrirAcuerdo = this.abrirAcuerdo.bind(this);

        this.activebuttonf = this.activebuttonf.bind(this);
        this.disabledbuttonf = this.disabledbuttonf.bind(this);

        this.activePersonaViva = this.activePersonaViva.bind(this);

        this.changeRostroBase64 = this.changeRostroBase64.bind(this);

        this.abrirModalModocedula = this.abrirModalModocedula.bind(this);
        this.cerrarModalModocedula = this.cerrarModalModocedula.bind(this);


        this.abrirModalCamaracedula = this.abrirModalCamaracedula.bind(this);
        this.cerrarModalCamaracedula = this.cerrarModalCamaracedula.bind(this);

        this.abrirmodalarchivocedula = this.abrirmodalarchivocedula.bind(this);
        this.cerrarmodalarchivocedula = this.cerrarmodalarchivocedula.bind(this);

        this.showiconGuardPdfExitoCedula = this.showiconGuardPdfExitoCedula.bind(this);
        this.showiconGuardCedulaExito = this.showiconGuardCedulaExito.bind(this);


    }


    obtenerTime() {
        const token = this.state.token_nueva_cuenta;
        const tokendecode = jwt(token);
        const exp = tokendecode.exp; // segundos UNIX
        const fechaExpiracion = new Date(exp * 1000); // UTC → Date válido
        // Limpiar timer anterior
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
        }
        // Iniciar cuenta regresiva
        this.timerInterval = setInterval(() => {
            const ahora = new Date();
            const diff = fechaExpiracion - ahora;
            if (diff <= 0) {
                clearInterval(this.timerInterval);
                this.setState({
                    tiempoRestante: "Sesión expirada",
                    redirectInicio: true,
                });
            } else {
                const horas = Math.floor(diff / (1000 * 60 * 60));
                const minutos = Math.floor((diff / (1000 * 60)) % 60);
                const segundos = Math.floor((diff / 1000) % 60);
                const tiempo =
                    `${horas.toString().padStart(2, "0")}:` +
                    `${minutos.toString().padStart(2, "0")}:` +
                    `${segundos.toString().padStart(2, "0")}`;
                this.setState({ tiempoRestante: tiempo });
            }
        }, 1000);
    }

    componentWillMount() {
        this.obtenerTime();
    }

    activebuttonf() {
        this.setState({ activebutton: true });
    }

    disabledbuttonf() {
        this.setState({ activebutton: false });
    }

    activePersonaViva() {
        this.setState({ personaviva: true });
    }

    changeRostroBase64(variable) {
        this.setState({ rostro_base64: variable });
    }

    abrirAcuerdo() {
        this.setState({ verAcuerdo: true });
    }

    abrirMensajeconocimiento() {
        this.setState({ verMensajeConocimiento: true })
    }

    abrirModalSugerencia() {
        this.setState({
            modalSugerencia: {
                ...this.state.modalSugerencia,
                show: true
            }
        });
    }

    cerrarModalSugerencia() {
        this.setState({
            modalSugerencia: {
                titulo: "",
                mensaje: "",
                imagen: "",
                listSug: [],
                show: false
            }
        });
    }

    abrirModalError() {
        this.setState({ modalError: true });
    }

    cerrarModalError() {
        this.setState({ modalError: false })
    }

    cerrarModalSesionExpirada() {
        window.location.href = "/inicio";
    }
    /*
        renderFormRegistroContrasenia(valor) {
            //console.log("cambio->" , valor);
            //console.log(this.state.datosUsuario);
            this.setState({ verFormRegistroContrasenia: valor })
        }
    */


    postVerificarAlias = async () => {
        this.disabledbuttonf();
        var datos = {
            alias: this.state.datosUsuario.alias_sugerido,
            nombres: this.state.datosUsuario.nombres,
            apellidos: this.state.datosUsuario.apellidos
        }
        axios.post(`${process.env.REACT_APP_API}api/CuentaUsuario/verificaralias`, datos,
            {
                headers: {
                    Authorization: `Bearer ${this.state.token_nueva_cuenta}`
                }
            }
        )
            .then(r => {
                if (r.data.success) {
                    this.state.mensaje_error_alias = r.data.message;
                    if (r.data.message === "El alias ingresado no tiene relación con el nombre o el apellido" || r.data.message === "No se ha podido recomendar un alias. Revise que sus nombres y Apellidos esten completos") {
                        this.state.listSugerencia = r.data.lSugerencia;
                        this.setState({
                            modalSugerencia: {
                                show: true,
                                titulo: "Sugerencia de alias",
                                mensaje: this.state.mensaje_error_alias,
                                imagen: info,
                                listSug: this.state.listSugerencia,
                            }
                        });
                    } else if (r.data.message === "El alias que ingreso ya se encuentra siendo utilizado. Le sugerimos que utilice el siguientes alias:") {
                        this.state.listSugerencia = r.data.lSugerencia;
                        this.setState({
                            modalSugerencia: {
                                show: true,
                                titulo: "Sugerencia de alias",
                                mensaje: this.state.mensaje_error_alias,
                                imagen: info,
                                listSug: this.state.listSugerencia,
                            }
                        });
                    }
                } else {
                    //this.abrirAcuerdo(); /*YA NO ES ABRIR ACUERDO, SINO QUE PASA DIRECTO A INGRESAR LA CONTRASEÑA Y CREAR LA CUENTA */
                    this.changeVerRegistroContrasenia(true);
                }
                this.activebuttonf();
            })
            .catch(error => {
                this.setState({ modalMensaje: error.response.data.errorMessage })
                this.abrirModalError();
                this.activebuttonf();
            });
    }

    abrirModalInfoGTSI() {
        this.setState({ modalIsOpen: true });
    }

    cerrarModalInfoGTSI() {
        this.setState({ modalIsOpen: false });
    }

    handlerDatosFormRegistro = async (e) => {
        await this.setState({
            datosUsuario: {
                ...this.state.datosUsuario,
                [e.target.name]: e.target.value,
            }
        })
        this.handlerOnBlur();
    }

    handlerOnBlur = async () => {
        if (this.state.datosUsuario.alias_sugerido === "") {
            await this.setState({
                errorSolicitud: {
                    ...this.state.errorSolicitud,
                    alias_sugerido: "El campo 'Alias sugerido' es requerido"
                }
            })
        } else if (!this.state.expresiones.alias_sugerido.test(this.state.datosUsuario.alias_sugerido.toLowerCase())) {
            await this.setState({
                errorSolicitud: {
                    ...this.state.errorSolicitud,
                    alias_sugerido: "El campo 'Alias sugerido' solo acepta entradas de este tipo: nombre.apellido",
                }
            })
        } else {
            this.setState({
                errorSolicitud: {
                    ...this.state.errorSolicitud,
                    alias_sugerido: ""
                }
            })
        }
    }



    /*INICIO NUEVO CODIGO ANGEL*/
    abrirModalModocedula() {
        if (this.state.tipoCargaDocumentoIdentidad == "image") {
            this.abrirModalCamaracedula();
        } else if (this.state.tipoCargaDocumentoIdentidad == "document") {
            this.abrirmodalarchivocedula();
        } else {
            this.setState({ modalModocedula: true });
        }
    }

    cerrarModalModocedula() {
        this.setState({ modalModocedula: false })
    }

    abrirModalCamaracedula() {
        this.setState({ modalCamaracedula: true });
        this.cerrarModalModocedula();

    }

    cerrarModalCamaracedula() {
        this.setState({ modalCamaracedula: false }, () => {
        })
    }

    abrirmodalarchivocedula() {
        this.setState({ modalarchivocedula: true });
        this.cerrarModalModocedula();
    }

    cerrarmodalarchivocedula() {
        this.setState({ modalarchivocedula: false })
    }

    Dataimgcedula = dataimgced => {
        if (dataimgced != null) {
            this.setState({
                cedula_base64: dataimgced,
                actCedula: true
            }, () => {
                this.changetipoCargaDocumentoIdentidad("image");
                this.cerrarModalCamaracedula();
                this.changeisCedulaAnalizada(false);

                this.ValidacionDatosCedulaConBase("image");
                this.showiconGuardCedulaExito();
                this.abrirvermodalresultvalidacionident();
            });
        }
    }

    filechooseCedula = chosefile => {
        console.log("filechooseCedula")
        if (chosefile != null) {
            this.setState({
                //fotoCedula: chosefile,
                cedula_base64: chosefile,
                actDocPdf: true
            }, () => {
                this.changetipoCargaDocumentoIdentidad("document");
                this.cerrarmodalarchivocedula();
                this.changeisCedulaAnalizada(false);

                this.ValidacionDatosCedulaConBase("pdf");

                this.showiconGuardCedulaExito();
                this.abrirvermodalresultvalidacionident();
            })
        }
    }

    showiconGuardPdfExitoCedula() {
        this.setState({
            iconGuardCedulaExito: true
        })
    }



    showiconGuardCedulaExito() {
        this.setState({
            iconGuardCedulaExito: true,
            actFirmaElec: true
        });
    }

    changeIsCedulaEqualRostro = (valor) => {
        this.setState({
            isCedulaEqualRostro: valor
        })
    }

    changeisCedulaAnalizada = (valor) => {
        this.setState({
            isCedulaAnalizada: valor
        })
    }

    changeIsNumCedulaEqualBase = (valor) => {
        this.setState({
            isNumCedulaEqualBase: valor
        })
    }


    ReconocimientoFacialCedula = async () => {
        try {
            const rostro = await base64ToFile(
                this.state.rostro_base64,
                "rostro.jpg"
            );
            const cedula = await base64ToFile(
                this.state.cedula_base64,
                "cedula.jpg"
            );

            const formData = new FormData();
            formData.append("image_one", rostro);
            formData.append("image_two", cedula);

            const r = await axios.post(
                `${process.env.REACT_APP_API_LIVENESS}/analysis/face-recognition/?metric=cosine&model=Facenet&threshold=0.1`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }
            );

            if (r.data.analysis_result.mismo_individuo) {
                this.changeIsCedulaEqualRostro(true);
                this.changeNumeroIntento(2);
                this.changenecesitaRevision(false);
            } else {
                this.changeIsCedulaEqualRostro(false);
                this.changeNumeroIntento(this.state.numerointento);
                this.changenecesitaRevision(true);
            }
            this.changeSpinnerUploadCamara(true);
            this.changeisCedulaAnalizada(true);
            this.changeIsNumCedulaEqualBase(true);
        } catch (error) {
            //console.error(error.response?.status || error.message || error);
            this.changeisCedulaAnalizada(true);
            this.changeNumeroIntento(this.state.numerointento);
            this.changeSpinnerUploadCamara(true);
            this.changeIsCedulaEqualRostro(false);
            this.changenecesitaRevision(true);
            //this.changeIsNumCedulaEqualBase(false);
        }
    }



    ValidacionDatosCedulaConBase = async (tipo) => {
        console.log("ValidacionDatosCedulaConBase")
        try {
            this.changeSpinnerUploadCamara(false);
            const cedulaPdf = base64ToPdfFile(
                this.state.cedula_base64,
                "cedula.pdf"
            );

            const formData = new FormData();
            formData.append("file", cedulaPdf);
            formData.append("type_document", "cedula");

            const r = await axios.post(
                `${process.env.REACT_APP_API_LIVENESS}/analysis/ci-pv/extraccion`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }
            );

            if (r.data.human_revision) {
                this.changenecesitaRevision(true);
                this.changeIsNumCedulaEqualBase(false);
                this.changeIsCedulaEqualRostro(false);
                this.changeSpinnerUploadCamara(true);
                this.changeisCedulaAnalizada(true);
                this.changeNumeroIntento(this.state.numerointento);
            } else {
                /*DEBUG*/
                //if (r.data.extracted_data.numero_cedula == "0951500693") {
                
                // Producción 
                if (r.data.extracted_data.numero_cedula == this.state.datosUsuario.identificacion) {
                    await this.ReconocimientoFacialCedula();
                    this.changeIsNumCedulaEqualBase(true);
                    /*this.changenecesitaRevision(false);
                    ;
                    this.changeSpinnerUploadCamara(true);
                    this.changeNumeroIntento(2) ;               */
                } else {
                    this.changenecesitaRevision(true);
                    this.changeIsNumCedulaEqualBase(false);
                    this.changeIsCedulaEqualRostro(false);
                    this.changeSpinnerUploadCamara(true);
                    this.changeisCedulaAnalizada(true);

                    this.changeNumeroIntento(this.state.numerointento);

                }
            }
        } catch (error) {
            this.changeSpinnerUploadCamara(true);
            this.changenecesitaRevision(true);
            this.changeisCedulaAnalizada(true);
            this.changeIsNumCedulaEqualBase(false);
            this.changeIsCedulaEqualRostro(false);
            this.changeNumeroIntento(this.state.numerointento);
        }
    }





    change_cedula_base64 = (valor) => {
        this.setState({
            cedula_base64: valor
        })
    }

    changenecesitaRevision = (valor) => {
        this.setState({
            necesitaRevision: valor
        })
    }


    abrirModalMessage = () => {
        this.setState({
            modalMessage: {
                ...this.state.modalMessage,
                show: true
            }
        });
    }

    cerrarModalMessage = () => {
        this.setState({
            modalMessage: {
                titulo: "",
                mensaje: "",
                imagen: "",
                show: false
            }
        });
    }

    abrirvermodalresultvalidacionident = () => {
        this.setState({
            vermodalresultvalidacionident: true
        }, () => {
        });
    }
    cerrarvermodalresultvalidacionident = () => {
        this.setState({
            vermodalresultvalidacionident: false
        });
    }

    seguirIngresoContraseña = () => {
        this.setState({
            vermodalresultvalidacionident: false
        });
        console.log(this.state.numerointento +" >= " + Number(process.env.REACT_APP_NUMERO_INTENTO_EXTRACCION_CEDULA))
        if (this.state.numerointento >= Number(process.env.REACT_APP_NUMERO_INTENTO_EXTRACCION_CEDULA)) {
            this.postVerificarAlias();
        }
        else {
            if (this.state.tipoCargaDocumentoIdentidad == "image") {
                this.abrirModalCamaracedula();
            } else if (this.state.tipoCargaDocumentoIdentidad == "document") {
                this.abrirmodalarchivocedula();
            }
        }
    }



    changeSpinnerUploadCamara = (valor) => {
        this.setState({
            spinnerUploadCamara: valor
        })
    }

    changeVerRegistroContrasenia = (valor) => {
        this.setState({ verRegistroContrasenia: valor });
    }

    cerrarModalSubirPdf = () => {
        this.setState({
            modalSubirPdf: false,
            modalarchivocedula: false
        })
    }
    changeNumeroIntento = (valor) => {
        console.log("changeNumeroIntento")
        this.setState({
            numerointento: valor + 1
        },()=>{
            console.log(this.state.numerointento)
        })
    }

    changetipoCargaDocumentoIdentidad = (valor) => {
        this.setState({
            tipoCargaDocumentoIdentidad: valor
        })
    }


    /* FIN NUEVO CODIGO ANGEL */
    render() {
        var contenido;

        if (this.state.redirectInicio) {
            return (
                <Modal cerrarModal={this.cerrarModalSesionExpirada} verBoton={true} textoBoton="ACEPTAR" >
                    <p className='text-center'><strong>Sesión expirada</strong></p>
                    <div className='mt-6 mb-6'>
                        <img className="registro-check" src={equis} alt="Error"></img>
                    </div>
                    <p className='text-center'>Será redireccionado a la página de inicio.</p>
                </Modal>
            )
        } else if (!this.state.personaviva) {
            /* return (
                 <LivenessModal
                     activePersonaViva={this.activePersonaViva}
                     changeRostroBase64={this.changeRostroBase64}
                 />
             )*/
            contenido = (
                <LivenessModal
                    activePersonaViva={this.activePersonaViva}
                    changeRostroBase64={this.changeRostroBase64}
                />
            )
        } else if (this.state.verRegistroContrasenia) {
            contenido = (
                <FormRegistroContrasenia
                    identificacion={this.state.datosUsuario.identificacion}
                    nombres={this.state.datosUsuario.nombres}
                    apellidos={this.state.datosUsuario.apellidos}
                    alias_sugerido={this.state.datosUsuario.alias_sugerido}
                    usuario_sugerido={this.state.datosUsuario.usuarioEscogido}
                    correoAlterno={this.state.datosUsuario.correoAlterno}
                    rol={this.state.datosUsuario.rol}
                    telefono={this.state.datosUsuario.telefono}
                    unidad={this.state.datosUsuario.unidad}
                    idAcFirmaElec={this.state.idAcFirmaElec}
                    tipoForm={"A"}
                    cedula_base64={this.state.cedula_base64}
                    rostro_base64={this.state.rostro_base64}
                    IsFirmadoElect={false}
                    callTagManager={this.props.callTagManager}
                    necesitaRevision={this.state.necesitaRevision}
                //useEffect={this.props.useEffect}
                ></FormRegistroContrasenia>
            );
        } else {
            contenido = (
                <>
                    {this.state.verAcuerdo ? (
                        <Acuerdo
                            identificacion={this.state.datosUsuario.identificacion}
                            nombres={this.state.datosUsuario.nombres}
                            apellidos={this.state.datosUsuario.apellidos}
                            alias_sugerido={this.state.datosUsuario.alias_sugerido}
                            usuario_sugerido={this.state.datosUsuario.usuarioEscogido}
                            correoAlterno={this.state.datosUsuario.correoAlterno}
                            rol={this.state.datosUsuario.rol}
                            telefono={this.state.datosUsuario.telefono}
                            unidad={this.state.datosUsuario.unidad}
                            tipoForm={"A"}
                            mensaje_titulo="CREAR CUENTA"
                            verbtngeneral={false}
                            verbtngeneralElectronica={true}
                            callTagManager={this.props.callTagManager}
                            /* useEffect={this.props.useEffect}*/
                            showHeader={false}
                        />
                    )
                        :
                        (
                            <div >
                                <CenteredWrapper>
                                    <div className="registro-container">
                                        <div className="container">
                                            <div className="row">
                                                <BotonExpandible
                                                    mensaje={
                                                        <div style={{ textAlign: "left" }}>
                                                            <strong>
                                                                Si la información presentada no es correcta por favor contactarse con{" "}
                                                                <a href="mailto:gerenciatecnologia@espol.edu.ec">
                                                                    gerenciatecnologia@espol.edu.ec
                                                                </a>
                                                            </strong>
                                                            <br /><br />
                                                            <em style={{ fontWeight: 200 }}>
                                                                El campo Alias sugerido es un identificador adicional de la cuenta, solo
                                                                sirve para que otras personas puedan enviarte correos electrónicos.
                                                            </em>
                                                        </div>

                                                    }
                                                />
                                            </div>
                                            <div className="row">
                                                <div className="col-12 ">
                                                    <p className="registro-title">CREAR CUENTA</p>
                                                </div>
                                            </div>

                                            <div className='row-form-e'>
                                                <div className="row-form-datos-e col-10">
                                                    <div className="col-12 col-md-12 col-xl-11 mt-2" >
                                                        <label htmlFor="identificacion" id="registro-textoLabel">IDENTIFICACIÓN </label>
                                                        <input className="form-control" type="text" name="identificacion" defaultValue={this.state.datosUsuario.identificacion} disabled></input>
                                                    </div>

                                                    <div className="col-12 col-md-12 col-xl-11  mt-2"  >
                                                        <label id="registro-textoLabel" htmlFor="nombres">NOMBRE(S) </label>
                                                        <input className="form-control" type="text" name="nombres" defaultValue={this.state.datosUsuario.nombres.toUpperCase()} disabled></input>
                                                    </div>

                                                    <div className="col-12 col-md-12 col-xl-11 mt-2" >
                                                        <label id="registro-textoLabel" htmlFor="apellidos">APELLIDO(S) </label>
                                                        <input className="form-control" type="text" name="apellidos" defaultValue={this.state.datosUsuario.apellidos.toUpperCase()} disabled></input>
                                                    </div>

                                                    <div className="col-12 col-md-12 col-xl-11 mt-2">

                                                        <label id="registro-textoLabel" htmlFor="alias_sugerido">ALIAS SUGERIDO: </label>

                                                        <div className="input-group">
                                                            <input
                                                                type="text"
                                                                className={this.state.errorSolicitud.alias_sugerido ? "form-control olvidoContra-input-error" : "form-control"}
                                                                id="alias"
                                                                placeholder="nombre.apellido"
                                                                name="alias_sugerido"
                                                                //defaultValue={this.state.datosUsuario.alias_sugerido}
                                                                value={this.state.datosUsuario.alias_sugerido}
                                                                onChange={this.handlerDatosFormRegistro}
                                                                onBlur={this.handlerOnBlur}
                                                            />
                                                            <div id="registro-textoLabel" className="input-group-text" style={{ backgroundColor: "#E9ECEF" }}>@espol.edu.ec</div>
                                                        </div>
                                                        <p className='solicitud-info'>Formato: nombre.apellido</p>

                                                        {this.state.errorSolicitud.alias_sugerido &&
                                                            <p className='solicitud-leyenda'>{this.state.errorSolicitud.alias_sugerido}</p>
                                                        }
                                                    </div>
                                                    {/*<div className="col-12 col-md-12 col-xl-11 mt-2">
                                                        <label id="registro-textoLabel" htmlFor="alias_sugerido">Documento de identificación</label>
                                                        <div className="paso-icono">
                                                            {this.state.iconGuardCedulaExito && this.state.isCedulaAnalizada ?
                                                                <>
                                                                    {this.state.isCedulaEqualRostro ?
                                                                        <button onClick={this.abrirModalModocedula} className="acuerdo-modal-btn">
                                                                            <img className="acuerdo-modal-logo" src={cedimg_veri} alt="Exitoso"></img>
                                                                        </button>
                                                                        :
                                                                        <button onClick={this.abrirModalModocedula} className="acuerdo-modal-btn">
                                                                            <img className="acuerdo-modal-logo" src={cedimg_noveri} alt="Exitoso"></img>
                                                                        </button>
                                                                    }
                                                                </>
                                                                :
                                                                <button onClick={this.abrirModalModocedula} className="acuerdo-modal-btn">
                                                                    <img className="acuerdo-modal-logo" src={cedimg} alt="Subir imagen"></img>
                                                                </button>
                                                            }
                                                            <div>
                                                                {!this.state.spinnerUploadCamara ?
                                                                    <span className="registroContra-fr-top spinner-border text-primary ms-2" role="status" aria-hidden="true"></span>
                                                                    : null}
                                                                {this.state.isCedulaAnalizada && (
                                                                    <>
                                                                        {this.state.isNumCedulaEqualBase ?
                                                                            (<p className='mensaje-exito'>Se valido el número de identificación.</p>)
                                                                            :
                                                                            (<p className='mensaje-error'>Hubo un error validando la coincidencia del número de identificación.</p>)
                                                                        }
                                                                        {this.state.isCedulaEqualRostro ?
                                                                            (<p className='mensaje-exito'>Se valido el rostro de la persona.</p>)
                                                                            :
                                                                            (<p className='mensaje-error'>Hubo un error validando el rostro de la persona.</p>)
                                                                        }
                                                                    </>
                                                                )}
                                                                {this.state.necesitaRevision && this.state.isCedulaAnalizada &&
                                                                    <p className='solicitud-info'>No se pudo validar correctamente. Se creará una solicitud.</p>
                                                                }
                                                            </div>
                                                        </div>


                                                    </div>*/}

                                                </div>

                                                <br />

                                                <div className="row-seleccion-usuario">
                                                    <div className="row-seleccion-usuario-texto mt-4">
                                                        <label id="registro-textoLabel" >SELECCIONE UN USUARIO: </label>
                                                        {/* <p align="justify" className='solicitud-infor'>El campo "Usuario sugerido" es el identificador que deberá usar para acceder a los sistemas de la ESPOL.</p> */}
                                                    </div>

                                                    <div className="row-seleccion-usuario-opciones">
                                                        <div className="col-xl-12 mt-3 usuarios">
                                                            {this.state.datosUsuario.listaUsuarios.map((value, index) => {
                                                                return (
                                                                    <div className="form-check" key={index}>
                                                                        <input className="form-check-input"
                                                                            type="radio" name="usuarioEscogido"
                                                                            id="usuarioEscogido" value={value}
                                                                            onClick={this.handlerDatosFormRegistro}
                                                                        />
                                                                        <label className="form-check-label" htmlFor="usuarioEscogido">{value}</label>
                                                                    </div>
                                                                );
                                                            })}
                                                            {/* {this.state.datosUsuario.listaUsuarios.map((value, index) => {
                                                        return (
                                                            <RadioSwitch
                                                                key={index}
                                                                name="usuarioEscogido"
                                                                value={value}
                                                                label={value}
                                                                checked={this.state.usuarioEscogido === value}
                                                                onChange={(val) => {
                                                                    this.setState({ usuarioEscogido: val });
                                                                    this.handlerDatosFormRegistro(val); // llamas tu handler
                                                                }}
                                                            />
                                                        );
                                                    })} */}
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>



                                            <br />
                                            {/* <br /> */}

                                            <div className="registro-container-botonGuardar">
                                                <button
                                                    disabled={
                                                        this.state.datosUsuario.identificacion &&
                                                            this.state.datosUsuario.nombres &&
                                                            this.state.datosUsuario.apellidos &&
                                                            this.state.datosUsuario.alias_sugerido &&
                                                            this.state.datosUsuario.usuarioEscogido &&
                                                            !this.state.errorSolicitud.alias_sugerido &&
                                                            /* this.state.activebutton &&*/
                                                            this.state.spinnerUploadCamara
                                                            ? false : true}
                                                    type="submit"
                                                    className={
                                                        this.state.datosUsuario.identificacion &&
                                                            this.state.datosUsuario.nombres &&
                                                            this.state.datosUsuario.apellidos &&
                                                            this.state.datosUsuario.alias_sugerido &&
                                                            this.state.datosUsuario.usuarioEscogido &&
                                                            !this.state.errorSolicitud.alias_sugerido &&
                                                            this.state.activebutton &&
                                                            this.state.personaviva &&
                                                            /*this.state.iconGuardCedulaExito &&*/
                                                            this.state.spinnerUploadCamara
                                                            ?
                                                            "registro-btn-submit" : "registro-btn-submit-disabled"}
                                                    onClick={this.abrirModalModocedula}>SEGUIR
                                                </button>
                                                {!this.state.activebutton ?
                                                    <span className="registroContra-fr-top spinner-border text-primary ms-2" role="status" aria-hidden="true"></span>
                                                    : null}

                                            </div>
                                        </div>
                                    </div>
                                </CenteredWrapper>
                                <Footer />

                                {this.state.modalIsOpen &&
                                    <Modal isOpen={this.state.modalIsOpen} cerrarModal={this.cerrarModalInfoGTSI} verBoton={false}>
                                        <p className="text-justify">
                                            Comunicarse con la Gerencia de Tecnologías y Servicios de Información</p>
                                        <p><strong>Teléfono: </strong>(+593)42269256</p>
                                        <p><strong>Atención: </strong>Lunes a Viernes de 08:00 a 16:00</p>
                                        <p>gerenciatecnologia@espol.edu.ec</p>
                                    </Modal>}

                                {this.state.modalError &&
                                    <Modal isOpen={this.state.modalError} cerrarModal={this.cerrarModalError} verBoton={true} textoBoton="ACEPTAR" >
                                        <p className='text-center'><strong>Error en la Solicitud</strong></p>
                                        <div className='mt-6 mb-6'>
                                            <img className="registro-check" src={equis} alt="Error"></img>
                                        </div>
                                        <p className='text-center'>{this.state.modalMensaje}</p>
                                    </Modal>
                                }

                                {this.state.modalSugerencia.show &&
                                    <Modal isOpen={this.state.modalSugerencia.show} cerrarModal={this.cerrarModalSugerencia} verBoton={true} textoBoton="ACEPTAR" >
                                        <p className='text-center'><strong>{this.state.modalSugerencia.titulo}</strong></p>
                                        <div className='mt-6 mb-6'>
                                            <img className="registroContra-check" src={this.state.modalSugerencia.imagen} alt="Exitoso"></img>
                                        </div>

                                        <p className='text-center'>{this.state.modalSugerencia.mensaje}</p>
                                        <div className="divCentrar">
                                            <ul className='solicitud-menulist' >
                                                <b>{this.state.modalSugerencia.listSug.map((sugerencia) => <li>{sugerencia}</li>)}</b>
                                            </ul>
                                        </div>
                                    </Modal>
                                }

                                {
                                    this.state.modalModocedula &&
                                    <Modal isOpen={this.state.modalModocedula} cerrarModal={this.cerrarModalModocedula} verBoton={false} >
                                        <div className='documento-identidad'>
                                            <p className='text-center acuerdo-modalFME-titulo'><strong>Subir documento de identidad</strong></p>
                                            <br />
                                            <div className="col-10">
                                                <NotificacionTip mensaje="Seleccione el método para subir el documento de identidad" />
                                            </div>
                                            <br />
                                            <div className="row-opciones-documento" >
                                                {
                                                    isMobile &&
                                                    <div className="col-10">
                                                        <button onClick={this.abrirModalCamaracedula} className="identidad-camara-button">
                                                            <div className="row" style={{ justifyContent: 'center' }} >
                                                                <div className=" col-10 col-md-10 col-xl-10">
                                                                    <p className="acuerdo-recuadro-texto-button">Cámara</p>
                                                                </div>
                                                            </div>
                                                        </button>
                                                    </div>
                                                }
                                                <div className="col-10">
                                                        <button onClick={this.abrirmodalarchivocedula} className="identidad-documento-button">
                                                            <div className="row" style={{ justifyContent: 'center' }} >
                                                                <div className=" col-10 col-md-10 col-xl-10">
                                                                    <p className="acuerdo-recuadro-texto-button">Subir PDF</p>
                                                                </div>
                                                            </div>
                                                        </button>
                                                    </div>
                                                {/*
                                                <div className="col-10">
                                                    <button onClick={this.abrirModalCamaracedula} className="identidad-camara-button">
                                                        <div className="row" style={{ justifyContent: 'center' }} >
                                                            <div className=" col-10 col-md-10 col-xl-10">
                                                                <p className="acuerdo-recuadro-texto-button">Cámara</p>
                                                            </div>
                                                        </div>
                                                    </button>
                                                </div>
                                                <div className="col-10">
                                                    <button onClick={this.abrirmodalarchivocedula} className="identidad-documento-button">
                                                        <div className="row" style={{ justifyContent: 'center' }} >
                                                            <div className=" col-10 col-md-10 col-xl-10">
                                                                <p className="acuerdo-recuadro-texto-button">Subir PDF</p>
                                                            </div>
                                                        </div>
                                                    </button>
                                                </div>
                                            */}
                                            </div>
                                        </div>
                                    </Modal>
                                }
                                {
                                    this.state.modalCamaracedula &&
                                    <Modal isOpen={this.state.modalCamaracedula} cerrarModal={this.cerrarModalCamaracedula} verBoton={false} >
                                        <Camara imgRostro={this.Dataimgcedula} rostro={false} identificacion={this.state.datosUsuario.identificacion} />
                                    </Modal>
                                }

                                {
                                    this.state.modalarchivocedula &&
                                    <ModalXL modalXXL={true} isOpen={this.state.modalSubirPdf} cerrarModal={this.cerrarModalSubirPdf} verBoton={false} >
                                        <Visualizarpdf choosepdf={this.filechooseCedula} abrirAuto={true}/>
                                    </ModalXL>
                                }
                                {this.state.modalMessage.show &&
                                    <Modal isOpen={this.state.modalMessage.show} cerrarModal={this.cerrarModalMessage} verBoton={true} textoBoton="ACEPTAR" >
                                        <p className='text-center'><strong>{this.state.modalMessage.titulo}</strong></p>
                                        <div className='mt-6 mb-6' align="center">
                                            <img className="nacionalidad-check" src={this.state.modalMessage.imagen} alt="Exitoso"></img>
                                        </div>
                                        <p className='text-center'>{this.state.modalMessage.mensaje}</p>
                                    </Modal>
                                }


                                {this.state.vermodalresultvalidacionident &&
                                    <Modal
                                        isOpen={this.state.vermodalresultvalidacionident}
                                        cerrarModal={this.cerrarvermodalresultvalidacionident}
                                        verBoton={false}
                                        textoBoton="Validar identificación"
                                        srcImagen={
                                            this.state.iconGuardCedulaExito && this.state.isCedulaAnalizada &&
                                                (
                                                    this.state.isCedulaEqualRostro
                                                        ? cedimg_veri
                                                        : cedimg_noveri
                                                )
                                        }
                                        claseHeader={
                                            this.state.iconGuardCedulaExito && this.state.isCedulaAnalizada &&
                                                (
                                                    this.state.isCedulaEqualRostro
                                                        ? "identificador_exito"
                                                        : "identificador_error"
                                                )
                                               
                                        }
                                    >
                                        <div className="row modal_nuevo">
                                            {!this.state.spinnerUploadCamara ?
                                                <h4 className='text-center'><strong>Validando documento...</strong></h4>
                                            :
                                                null
                                            }
                                            <div className="paso-icono">
                                                {!this.state.spinnerUploadCamara ?
                                                    <img className="acuerdo-modal-logo" src={focoanimado} alt="Cargando..." style={{ objectFit: "contain", height: "100px", width: "100%" }}></img>
                                                    :
                                                    <>
                                                        {/*this.state.iconGuardCedulaExito && this.state.isCedulaAnalizada ?
                                                            <>
                                                                {this.state.isCedulaEqualRostro ?                
                                                                    <img className="acuerdo-modal-logo" src={cedimg_veri} alt="Exitoso"></img>
                                                                    :    
                                                                    <img className="acuerdo-modal-logo" src={cedimg_noveri} alt="Exitoso"></img>                                                            
                                                                }
                                                            </>
                                                        :
                                                            <img className="acuerdo-modal-logo" src={cedimg} alt="Subir imagen"></img>
                                                        */}
                                                        <div className="contenedor-mensaje-modal">
                                                            {this.state.isCedulaAnalizada && (
                                                                <>
                                                                    {this.state.isNumCedulaEqualBase ?
                                                                        (
                                                                            <div className="contenedor-interno-mensaje-modal">
                                                                                <img className="icon-text" src={checkcc} alt="Exito"></img>
                                                                                <div className="mensaje-modal">
                                                                                    <p className='mensaje-informativo'>Se validó con éxito el número de identificación</p>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                        :
                                                                        (
                                                                            <div className="contenedor-interno-mensaje-modal">
                                                                                <img className="icon-text" src={error} alt="Subir imagen"></img>
                                                                                <div className="mensaje-modal">
                                                                                    <p className='mensaje-error'>Documento de identidad no admitido</p>
                                                                                    <p>Asegurese de que:</p>
                                                                                    <ol>
                                                                                        <li>Identidad <span>(los datos pertenezcan al titular solicitante)</span></li>
                                                                                        <li>Calidad de imagen <span>(fotografía nítida, enfocada y sin reflejos que obstruya la legibilidad)</span></li>
                                                                                        <li>Documento íntegro <span>(sin daños ni enmendaduras)</span></li>
                                                                                    </ol>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    }
                                                                    {this.state.isCedulaEqualRostro ?
                                                                        (
                                                                            <div className="contenedor-interno-mensaje-modal">
                                                                                <img className="icon-text" src={checkcc} alt="Exito"></img>
                                                                                <div className="mensaje-modal">
                                                                                    <p className='mensaje-informativo'>Se valido el rostro de la persona.</p>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                        :
                                                                        (
                                                                            <div className="contenedor-interno-mensaje-modal">
                                                                                <img className="icon-text" src={error} alt="Subir imagen"></img>
                                                                                <div className="mensaje-modal">
                                                                                    <p className='mensaje-error'>Error de validación de rostro de la persona</p>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    }
                                                                </>
                                                            )}
                                                            {this.state.necesitaRevision && this.state.isCedulaAnalizada && this.state.numerointento >= Number(process.env.REACT_APP_NUMERO_INTENTO_EXTRACCION_CEDULA) &&
                                                                <div className="contenedor-interno-mensaje-modal">
                                                                    <img className="icon-text" src={alerta} alt="alerta"></img>
                                                                    <div className="mensaje-modal">
                                                                        <p className='mensaje-informativo'>No se pudo validar correctamente. Se creará una solicitud para que un asesor verifique la información</p>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    </>
                                                }
                                            </div>
                                            {!this.state.spinnerUploadCamara ?
                                                null
                                                :
                                                <button onClick={this.seguirIngresoContraseña} className="modal-btn-submit">
                                                    {this.state.numerointento >= Number(process.env.REACT_APP_NUMERO_INTENTO_EXTRACCION_CEDULA) ?
                                                        <p className="n">Seguir</p>
                                                        :
                                                        <p className="">Volver a validar</p>
                                                    }
                                                </button>
                                            }
                                        </div>
                                    </Modal>
                                }
                            </div >
                        )
                    }
                </>
            )
        }
        return (
            <>
                <Header ifShowTime={true} tiempoRestante={this.state.tiempoRestante} />
                {contenido}
            </>
        )
    }
}

export default FormRegistro
